"use client"

import { useSession } from "@/features/auth/context/session.context"
import {
  shouldMaskHomeownerData,
  maskHomeownerLastName,
} from "@/shared/lib/utils/homeowner-privacy.utils"
import Heading from "@/shared/components/ui/typography/heading"

type Props = { fullname: string | null | undefined; homeownerUserId?: number | null }

export default function HomeownerDetailHeading({ fullname, homeownerUserId }: Props) {
  const { session } = useSession()
  const mask = shouldMaskHomeownerData(session?.role, session?.sub, homeownerUserId)
  const display = fullname
    ? mask
      ? maskHomeownerLastName(fullname)
      : fullname
    : "N/A"
  return <Heading>{display}</Heading>
}
